module.exports = __webpack_public_path__ + "img/triangle.75e70cda.svg";